import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterUsersVerificationView.
 * @extends JetView
 */
export default class FilterUsersVerificationView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        var response = []; // Array to hold response data
        var image; // Variable to hold the image for DNI Anterior
        var image2; // Variable to hold the image for DNI Posterior
        var count = 0; // Counter for tracking actions
        var optionsTypes = []; // Array to hold options for reasons

        // Configuration for customer summary section
        const customer_summary = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            id: 'Id',
                            minWidth: 200,
                            css: 'my_input',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            labelPosition: 'top',
                            disabled: false,
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            hotkey: 'enter',
                            width: 110,
                            css: 'my_btn',
                            height: 38,
                            click: () => {
                                count = 0; // Reset count on button click
                                let userId = $$('Id').getValue(); // Get user ID from input
                                if (userId != '') {
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .get(devConfig.geturlApi() + 'es/Client/GetClientById?id=' + userId, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message('Error! '); // Show error message on failure
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var userSelected = []; // Array to hold selected user data
                                                $$('form').clear(); // Clear the form
                                                var userSelected2 = [
                                                    {
                                                        DNIA: 'https://i.stack.imgur.com/lnYep.png',
                                                        DNIP: 'https://i.stack.imgur.com/lnYep.png',
                                                    },
                                                ];
                                                $$('form').parse(userSelected2); // Parse initial user data into the form
                                                if (text != '') {
                                                    var resp = JSON.parse(text); // Parse response text
                                                    if (resp.length > 0) {
                                                        userSelected.push(resp[0]); // Add the first response to userSelected
                                                        // Set the state switch based on user activation status
                                                        if (userSelected[0].IsActivateRegistroUsuario == 'A') {
                                                            $$('StateRegistroUsuarioSwith').setValue(1);
                                                        } else {
                                                            $$('StateRegistroUsuarioSwith').setValue(0);
                                                        }
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .get(
                                                                devConfig.geturlApi() +
                                                                    'UserManagement/GetUserLogs?Id=' +
                                                                    userId,
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message('Error! '); // Show error message on failure
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var resp2 = JSON.parse(text); // Parse logs response
                                                                        if (resp2.Data.length > 0) {
                                                                            resp2.Data.forEach((item2) => {
                                                                                // Check for previous DNI
                                                                                if (item2.Field == 'DNI Anterior') {
                                                                                    if (item2.StateId == 'P') {
                                                                                        userSelected[0].DNIA =
                                                                                            item2.Imagen; // Set previous DNI image
                                                                                        $$('buttonImage1').show(); // Show approve button
                                                                                        $$('buttonImage1R').show(); // Show reject button
                                                                                        $$('buttonImage1').define(
                                                                                            'IdLog',
                                                                                            item2.Id,
                                                                                        ); // Define log ID for approval
                                                                                        $$('buttonImage1R').define(
                                                                                            'IdLog',
                                                                                            item2.Id,
                                                                                        ); // Define log ID for rejection
                                                                                    }
                                                                                } else {
                                                                                    // Check for posterior DNI
                                                                                    if (
                                                                                        item2.Field == 'DNI Posterior'
                                                                                    ) {
                                                                                        if (item2.StateId == 'P') {
                                                                                            userSelected[0].DNIP =
                                                                                                item2.Imagen; // Set posterior DNI image
                                                                                            $$('buttonImage2').show(); // Show approve button
                                                                                            $$('buttonImage2R').show(); // Show reject button
                                                                                            $$('buttonImage2').define(
                                                                                                'IdLog',
                                                                                                item2.Id,
                                                                                            ); // Define log ID for approval
                                                                                            $$('buttonImage2R').define(
                                                                                                'IdLog',
                                                                                                item2.Id,
                                                                                            ); // Define log ID for rejection
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }
                                                                        $$('form').parse(userSelected); // Parse selected user data into the form
                                                                    },
                                                                },
                                                            );
                                                    }
                                                }
                                            },
                                        });
                                }
                            },
                        },
                        { gravity: 1 },
                        {
                            view: 'combo',
                            name: 'Estado',
                            minWidth: 200,
                            id: 'State',
                            css: 'my_combo',
                            label: _('Estado'),
                            labelPosition: 'top',
                            options: [
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                            disabled: true, // Combo is disabled initially
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Estado de Registro del Usuario'),
                                    align: 'center',
                                },
                                {
                                    id: 'StateRegistroUsuarioSwith',
                                    view: 'switch',
                                    labelWidth: 55,
                                    onLabel: _('Activo'),
                                    offLabel: _('Inactivo'),
                                    click: () => {
                                        let userId = $$('Id').getValue(); // Get user ID
                                        // Check if the switch is turned on and user ID is provided
                                        if ($$('StateRegistroUsuarioSwith').getValue() == 1 && userId != '') {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                    '{"Action":"RegistroUsuario","Id":' + userId + ',"IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            }); // Show error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            webix.message(_('Cambios Realizados')); // Show success message
                                                            $$('StateRegistroUsuarioSwith').setValue(1); // Set switch to active
                                                        },
                                                    },
                                                );
                                        } else {
                                            if (userId != '') {
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(devConfig.geturlApi() + 'Select/GetTypesReason', '', {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Show error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse reasons response
                                                            optionsTypes = resp.Data; // Store reasons in optionsTypes
                                                            webix
                                                                .ui({
                                                                    view: 'window',
                                                                    fullscreen: screen.width < 500 ? true : false,
                                                                    head: {
                                                                        view: 'toolbar',
                                                                        cols: [
                                                                            {
                                                                                view: 'label',
                                                                                label: _('Inactivar Usuario'),
                                                                            },
                                                                            {
                                                                                view: 'icon',
                                                                                icon: 'wxi-close',
                                                                                click: function () {
                                                                                    this.getTopParentView().hide(); // Close the window
                                                                                    count = 0; // Reset count
                                                                                    $$(
                                                                                        'StateRegistroUsuarioSwith',
                                                                                    ).setValue(1); // Reset switch to active
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                    position: 'center',
                                                                    modal: true,
                                                                    body: {
                                                                        view: 'form',
                                                                        id: 'stateUserForm',
                                                                        elements: [
                                                                            {
                                                                                margin: 10,
                                                                                rows: [
                                                                                    {
                                                                                        view: 'combo',
                                                                                        labelPosition: 'top',
                                                                                        label: _('Motivo'),
                                                                                        required: true,
                                                                                        name: 'Reason',
                                                                                        options: optionsTypes, // Set options for reasons
                                                                                    },
                                                                                ],
                                                                            },
                                                                            {
                                                                                cols: [
                                                                                    {
                                                                                        view: 'button',
                                                                                        value: _('Cancelar'),
                                                                                        click: function () {
                                                                                            this.getTopParentView().hide(); // Close the window
                                                                                            $$(
                                                                                                'stateUserForm',
                                                                                            ).setValues(
                                                                                                $$(
                                                                                                    'stateUserForm',
                                                                                                ).getCleanValues(),
                                                                                            ); // Reset form values
                                                                                            count = 0; // Reset count
                                                                                            $$(
                                                                                                'StateRegistroUsuarioSwith',
                                                                                            ).setValue(1); // Reset switch to active
                                                                                        },
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        type: 'form',
                                                                                        value: _('Guardar'),
                                                                                        click: function ($e) {
                                                                                            var values =
                                                                                                $$(
                                                                                                    'stateUserForm',
                                                                                                ).getValues(); // Get form values
                                                                                            if (
                                                                                                $$(
                                                                                                    'stateUserForm',
                                                                                                ).validate() // Validate form
                                                                                            ) {
                                                                                                let params = {
                                                                                                    Id: userId,
                                                                                                    Action: 'RegistroUsuario',
                                                                                                    IsActivate: 'I',
                                                                                                    Reason: values.Reason,
                                                                                                };
                                                                                                webix
                                                                                                    .ajax()
                                                                                                    .headers({
                                                                                                        'Content-type':
                                                                                                            'application/json',
                                                                                                    })
                                                                                                    .post(
                                                                                                        devConfig.geturlApi() +
                                                                                                            'Client/UpdateUserSecurity',
                                                                                                        params,
                                                                                                        {
                                                                                                            error: function (
                                                                                                                text,
                                                                                                                data,
                                                                                                                XmlHttpRequest,
                                                                                                            ) {
                                                                                                                webix.message(
                                                                                                                    'Error! ',
                                                                                                                ); // Show error message on failure
                                                                                                            },
                                                                                                            success:
                                                                                                                function (
                                                                                                                    text,
                                                                                                                    data,
                                                                                                                    XmlHttpRequest,
                                                                                                                ) {
                                                                                                                    text =
                                                                                                                        JSON.parse(
                                                                                                                            text,
                                                                                                                        ); // Parse response
                                                                                                                    if (
                                                                                                                        text.HasError
                                                                                                                    ) {
                                                                                                                        webix.message(
                                                                                                                            'Error: ' +
                                                                                                                                text.AlertMessage,
                                                                                                                        ); // Show error message if there's an error
                                                                                                                    } else {
                                                                                                                        webix.message(
                                                                                                                            'Usuario Inactivado',
                                                                                                                        ); // Show success message
                                                                                                                        $$(
                                                                                                                            'StateRegistroUsuarioSwith',
                                                                                                                        ).setValue(
                                                                                                                            0, // Set switch to inactive
                                                                                                                        );
                                                                                                                    }
                                                                                                                },
                                                                                                        },
                                                                                                    );
                                                                                                this.getTopParentView().hide(); // Close the window
                                                                                            } else {
                                                                                                webix.message({
                                                                                                    title: _('¡Error!'),
                                                                                                    type: 'alert-error',
                                                                                                    text: _(
                                                                                                        'Completa los campos...',
                                                                                                    ), // Show validation error message
                                                                                                });
                                                                                            }
                                                                                        },
                                                                                    },
                                                                                ],
                                                                            },
                                                                        ],
                                                                        elementsConfig: {
                                                                            on: {
                                                                                onChange: function () {
                                                                                    this.validate(); // Validate on change
                                                                                },
                                                                            },
                                                                        },
                                                                    },
                                                                })
                                                                .show(); // Show the window
                                                        },
                                                    });
                                            }
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Configuration for customer demographics section
        const customer_demographics = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'FirstName',
                            minWidth: 200,
                            label: _('Primer nombre'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'MiddleName',
                            minWidth: 200,
                            label: _('Segundo Nombre'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'LastName',
                            minWidth: 200,
                            label: _('Apellido'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'SecondLastName',
                            minWidth: 200,
                            label: _('Segundo Apellido'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'combo',
                            name: 'Gender',
                            minWidth: 200,
                            label: _('Género'),
                            labelPosition: 'top',
                            options: [
                                { id: 'M', value: _('Masculino') },
                                { id: 'F', value: _('Femenino') },
                            ],
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'BirthDate',
                            minWidth: 200,
                            label: _('Cumpleaños'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        { gravity: 2, id: 'grav' },
                    ],
                },
            ],
        };

        // Configuration for customer contact details section
        const customer_contact_details = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'MobilePhone',
                            minWidth: 200,
                            label: _('Celular'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'Email',
                            minWidth: 200,
                            label: _('Email'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        { gravity: 2, id: 'grav' },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'CountryId',
                            id: 'country',
                            localId: 'country:combo',
                            label: _('País Residencia'),
                            labelPosition: 'top',
                            options: [],
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'richselect',
                            name: 'RegionId',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región Residencia'),
                            labelPosition: 'top',
                            options: [],
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'richselect',
                            name: 'CityId',
                            id: 'City',
                            localId: 'cities:combo',
                            label: _('Ciudad Residencia'),
                            labelPosition: 'top',
                            options: [],
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'Address',
                            label: _('Dirección'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                    ],
                },
            ],
        };

        // Configuration for customer identification section
        const customer_identification = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'DocumentType',
                            localId: 'DocumentType:combo',
                            label: _('Tipo de Documento'),
                            labelPosition: 'top',
                            options: [
                                { id: 'C', value: _('DNI') },
                                { id: 'E', value: _('Cedula de Extranjería') },
                                { id: 'P', value: _('Pasaporte') },
                            ],
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'DocNumber',
                            minWidth: 200,
                            label: _('Numero de Documento'),
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        { gravity: 2, id: 'grav' },
                    ],
                },
            ],
        };

        // Configuration for customer identification check section
        const customer_identification_check = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        { gravity: 1 },
                        {
                            cols: [
                                {
                                    view: 'template2',
                                    height: 100,
                                    name: 'DNIA',
                                    template: function (obj) {
                                        image = obj; // Store the image for DNI Anterior
                                        if (typeof obj == 'string')
                                            return (
                                                '<h6 style=" margin: 0px; ">' +
                                                _('DNI Anterior') +
                                                "</h6><img class='dniAnterior' src='" +
                                                obj +
                                                "' style='cursor:pointer; width:80px; height:80px;'>"
                                            );
                                        return '<h6 style=" margin: 0px; ">' + _('No tiene DNI Anterior') + '</h6>';
                                    },
                                    onClick: {
                                        dniAnterior: function (ev, id) {
                                            webix
                                                .ui({
                                                    view: 'window',
                                                    move: true,
                                                    id: 'editwin',
                                                    width: 500,
                                                    height: 500,
                                                    fullscreen: screen.width < 500 ? true : false,
                                                    head: {
                                                        view: 'toolbar',
                                                        cols: [
                                                            {
                                                                view: 'label',
                                                                label: _('DNI Anterior'),
                                                                align: 'center',
                                                            },
                                                            {
                                                                view: 'icon',
                                                                icon: 'wxi-close',
                                                                click: function () {
                                                                    this.getTopParentView().hide(); // Close the window
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    modal: true,
                                                    position: 'center',
                                                    body: {
                                                        rows: [
                                                            {
                                                                template: function (obj) {
                                                                    return (
                                                                        "<img src='" +
                                                                        image +
                                                                        "' style='cursor:pointer; width:100%; height:100%;'>"
                                                                    ); // Display the DNI Anterior image
                                                                },
                                                            },
                                                        ],
                                                    },
                                                })
                                                .show(); // Show the window
                                        },
                                    },
                                },
                                {
                                    rows: [
                                        {
                                            view: 'button',
                                            id: 'buttonImage1',
                                            value: _('Aprobar'),
                                            width: 100,
                                            disabled: false,
                                            hidden: true, // Button is hidden initially
                                            click: function (obj) {
                                                var vvthis = this;
                                                webix.confirm({
                                                    type: 'confirm-warning',
                                                    text: _('Advertencia!') + '<br/>' + _('Desea Aprobar el log?'),
                                                    ok: _('Aprobar log'),
                                                    cancel: _('Salir'),
                                                    callback: function (action) {
                                                        if (action === true) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'Security/UpdateLogs',
                                                                    '{"Id":"' +
                                                                        $$('buttonImage1').config.IdLog +
                                                                        '", "State":"A"}',
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(_('Error! ')); // Show error message on failure
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var json = JSON.parse(text); // Parse response
                                                                            if (json.HasError) {
                                                                                webix.message({
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte',
                                                                                    ), // Show error message if there's an error
                                                                                });
                                                                            } else {
                                                                                webix.message({
                                                                                    text: _(
                                                                                        'Estado de log actualizado',
                                                                                    ), // Show success message
                                                                                    title: _('¡Exito!'),
                                                                                    type: 'alert-warning',
                                                                                });
                                                                                $$('buttonImage1').hide(); // Hide approve button
                                                                                $$('buttonImage1R').hide(); // Hide reject button
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    },
                                                });
                                            },
                                        },
                                        {
                                            view: 'button',
                                            id: 'buttonImage1R',
                                            value: _('Rechazar'),
                                            width: 100,
                                            disabled: false,
                                            hidden: true, // Button is hidden initially
                                            click: function (obj) {
                                                var vvthis = this;
                                                webix.confirm({
                                                    type: 'confirm-warning',
                                                    text: _('Advertencia!') + '<br/>' + _('Desea Rechazar el log?'),
                                                    ok: _('Rechazar log'),
                                                    cancel: _('Salir'),
                                                    callback: function (action) {
                                                        if (action === true) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'Security/UpdateLogs',
                                                                    '{"Id":"' +
                                                                        $$('buttonImage1R').config.IdLog +
                                                                        '", "State":"R"}',
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(_('Error! ')); // Show error message on failure
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var json = JSON.parse(text); // Parse response
                                                                            if (json.HasError) {
                                                                                webix.message({
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte',
                                                                                    ), // Show error message if there's an error
                                                                                });
                                                                            } else {
                                                                                webix.message({
                                                                                    text: _(
                                                                                        'Estado de log actualizado',
                                                                                    ), // Show success message
                                                                                    title: _('¡Exito!'),
                                                                                    type: 'alert-warning',
                                                                                });
                                                                                $$('buttonImage1').hide(); // Hide approve button
                                                                                $$('buttonImage1R').hide(); // Hide reject button
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    },
                                                });
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    view: 'template2',
                                    height: 100,
                                    name: 'DNIP',
                                    template: function (obj) {
                                        image2 = obj; // Store the image for DNI Posterior
                                        if (typeof obj == 'string')
                                            return (
                                                '<h6 style=" margin: 0px; ">' +
                                                _('DNI Posterior') +
                                                "</h6><img class='dniPorterior' src='" +
                                                obj +
                                                "' style='cursor:pointer; width:80px; height:80px;'>"
                                            );
                                        return '<h6 style=" margin: 0px; ">' + _('No tiene DNI Posterior') + '</h6>';
                                    },
                                    onClick: {
                                        dniPorterior: function (ev, id) {
                                            webix
                                                .ui({
                                                    view: 'window',
                                                    move: true,
                                                    id: 'editwin',
                                                    width: 500,
                                                    height: 500,
                                                    fullscreen: screen.width < 500 ? true : false,
                                                    head: {
                                                        view: 'toolbar',
                                                        cols: [
                                                            {
                                                                view: 'label',
                                                                label: _('DNI Posterior'),
                                                                align: 'center',
                                                            },
                                                            {
                                                                view: 'icon',
                                                                icon: 'wxi-close',
                                                                click: function () {
                                                                    this.getTopParentView().hide(); // Close the window
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    modal: true,
                                                    position: 'center',
                                                    body: {
                                                        rows: [
                                                            {
                                                                template: function (obj) {
                                                                    return (
                                                                        "<img src='" +
                                                                        image2 +
                                                                        "' style='cursor:pointer; width:100%; height:100%;'>"
                                                                    ); // Display the DNI Posterior image
                                                                },
                                                            },
                                                        ],
                                                    },
                                                })
                                                .show(); // Show the window
                                        },
                                    },
                                },
                                {
                                    rows: [
                                        {
                                            view: 'button',
                                            id: 'buttonImage2',
                                            value: _('Aprobar'),
                                            width: 100,
                                            disabled: false,
                                            hidden: true, // Button is hidden initially
                                            click: function (obj) {
                                                var vvthis = this;
                                                webix.confirm({
                                                    type: 'confirm-warning',
                                                    text: _('Advertencia!') + '<br/>' + _('Desea Aprobar el log?'),
                                                    ok: _('Aprobar log'),
                                                    cancel: _('Salir'),
                                                    callback: function (action) {
                                                        if (action === true) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'Security/UpdateLogs',
                                                                    '{"Id":"' +
                                                                        $$('buttonImage2').config.IdLog +
                                                                        '", "State":"A"}',
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(_('Error! ')); // Show error message on failure
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var json = JSON.parse(text); // Parse response
                                                                            if (json.HasError) {
                                                                                webix.message({
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte',
                                                                                    ), // Show error message if there's an error
                                                                                });
                                                                            } else {
                                                                                webix.message({
                                                                                    text: _(
                                                                                        'Estado de log actualizado',
                                                                                    ), // Show success message
                                                                                    title: _('¡Exito!'),
                                                                                    type: 'alert-warning',
                                                                                });
                                                                                $$('buttonImage2').hide(); // Hide approve button
                                                                                $$('buttonImage2R').hide(); // Hide reject button
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    },
                                                });
                                            },
                                        },
                                        {
                                            view: 'button',
                                            id: 'buttonImage2R',
                                            value: _('Rechazar'),
                                            width: 100,
                                            disabled: false,
                                            hidden: true, // Button is hidden initially
                                            click: function (obj) {
                                                var vvthis = this;
                                                webix.confirm({
                                                    type: 'confirm-warning',
                                                    text: _('Advertencia!') + '<br/>' + _('Desea Rechazar el log?'),
                                                    ok: _('Rechazar log'),
                                                    cancel: _('Salir'),
                                                    callback: function (action) {
                                                        if (action === true) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'Security/UpdateLogs',
                                                                    '{"Id":"' +
                                                                        $$('buttonImage2R').config.IdLog +
                                                                        '", "State":"R"}',
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(_('Error! ')); // Show error message on failure
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var json = JSON.parse(text); // Parse response
                                                                            if (json.HasError) {
                                                                                webix.message({
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte',
                                                                                    ), // Show error message if there's an error
                                                                                });
                                                                            } else {
                                                                                webix.message({
                                                                                    text: _(
                                                                                        'Estado de log actualizado',
                                                                                    ), // Show success message
                                                                                    title: _('¡Exito!'),
                                                                                    type: 'alert-warning',
                                                                                });
                                                                                $$('buttonImage2').hide(); // Hide approve button
                                                                                $$('buttonImage2R').hide(); // Hide reject button
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    },
                                                });
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        { gravity: 1 },
                    ],
                },
            ],
        };

        // Configuration for upper sections
        const upper_section_customer_summary = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [customer_summary], // Include customer summary section
                },
            ],
        };
        const upper_section_customer_demographics = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [customer_demographics], // Include customer demographics section
                },
            ],
        };
        const upper_section_customer_contact_details = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [customer_contact_details], // Include customer contact details section
                },
            ],
        };
        const upper_section_identification = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [customer_identification], // Include customer identification section
                },
            ],
        };
        const upper_section_identification_check = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [customer_identification_check], // Include customer identification check section
                },
            ],
        };

        // Configuration for accordion sections
        const accordion_section_summary = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    padding: 2,
                    rows: [
                        {
                            header: _('Resumen'),
                            id: 'ass',
                            body: {
                                padding: 10,
                                rows: [upper_section_customer_summary], // Include upper section for summary
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section_summary_mobil = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section_customer_summary], // Include upper section for summary
            },
        };
        const accordion_section_demographics = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    padding: 2,
                    rows: [
                        {
                            header: _('Demografía'),
                            id: 'asd',
                            body: {
                                padding: 10,
                                rows: [upper_section_customer_demographics], // Include upper section for demographics
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section_demographics_mobil = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section_customer_demographics], // Include upper section for demographics
            },
        };
        const accordion_section_contact_details = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    padding: 2,
                    rows: [
                        {
                            header: _('Contacto'),
                            id: 'asd',
                            body: {
                                padding: 10,
                                rows: [upper_section_customer_contact_details], // Include upper section for contact details
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section_contact_details_mobil = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section_customer_contact_details], // Include upper section for contact details
            },
        };
        const accordion_section_identification = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    padding: 2,
                    rows: [
                        {
                            header: _('Identificación'),
                            id: 'ass',
                            body: {
                                padding: 10,
                                rows: [upper_section_identification], // Include upper section for identification
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section_identification_mobil = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section_identification], // Include upper section for identification
            },
        };
        const accordion_section_identification_check = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    padding: 2,
                    rows: [
                        {
                            header: _('Verificación'),
                            id: 'ass',
                            body: {
                                padding: 10,
                                rows: [upper_section_identification_check], // Include upper section for identification check
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section_identification_mobil_check = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section_identification_check], // Include upper section for identification check
            },
        };

        // Configuration for filter popup window
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Información Usuario'),
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the window
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [
                    upper_section_customer_summary,
                    upper_section_customer_demographics,
                    upper_section_customer_contact_details,
                    upper_section_identification,
                    upper_section_identification_check,
                ],
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });

        // Main form configuration
        return {
            view: 'form',
            id: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500 ? accordion_section_summary : { height: 1, width: 0 },
                screen.width > 500 && screen.height > 500 ? accordion_section_demographics : { height: 1, width: 0 },
                screen.width > 500 && screen.height > 500 ? accordion_section_contact_details : { height: 1, width: 0 },
                screen.width > 500 && screen.height > 500 ? accordion_section_identification : { height: 1, width: 0 },
                screen.width > 500 && screen.height > 500
                    ? accordion_section_identification_check
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Show error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"')); // Parse countries response
                        var optionsCountries = $$('country').getList();
                        optionsCountries.clearAll(); // Clear existing options
                        optionsCountries.parse(data.Data); // Parse new options
                    },
                });
            $$('country').attachEvent('onChange', function (newv, oldv) {
                var optionscountries = this.getList().getItem(newv); // Get selected country
                var optionsProvinceRegions = $$('ProvinceRegion').getList();
                optionsProvinceRegions.clearAll(); // Clear existing province options
                if (optionscountries != undefined) {
                    optionsProvinceRegions.parse(optionscountries.departments); // Parse new province options
                }
            });
            $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
                var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province
                var optionsCity = $$('City').getList();
                optionsCity.clearAll(); // Clear existing city options
                if (optionsProvinceRegions != undefined) {
                    optionsCity.parse(optionsProvinceRegions.cities); // Parse new city options
                }
            });
        });
    }
}

// Extend webix UI with a custom template
webix.protoUI(
    {
        name: 'template2',
        getValue: function () {
            return this.getValues(); // Get values from the template
        },
        setValue: function (value) {
            this.setValues(value); // Set values for the template
        },
    },
    webix.ui.template,
);

// FILE DOCUMENTED
